export default __webpack_public_path__ + "static/media/photo2.97833c33.png";